import React from 'react';
import CreateEndorsedPage from 'src/components/CharityEndorsed/CreateEndorsedPage';
import CreateCommittedPage from 'src/components/CharityEndorsed/CreateCommittedPage';
import { enrol } from 'src/helpers/api/ab';

enum CharityEndorsedCommitment {
  Endorsement = 'A',
  Commitment = 'B',
}
import { CharityState } from 'src/redux/modules/charity/reducer';

interface Props {
  charity: CharityState;
  isEndorsementAccepted: boolean;
  changeEndorsementAcceptance: (
    checked: boolean,
    commitmentType: 'Endorsement' | 'Commitment'
  ) => void;
  defaultChecked?: boolean;
}

interface State {
  displayCharityOptions: boolean;
  abOption: string;
}

class CreateCharityEndorsedPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      displayCharityOptions: false,
      abOption: '',
    };
  }

  async componentDidMount() {
    const abOption = await enrol('cf_owner_charity_commitment_level');

    this.props.changeEndorsementAcceptance(
      true,
      abOption === CharityEndorsedCommitment.Endorsement
        ? 'Endorsement'
        : 'Commitment'
    );

    this.setState({
      displayCharityOptions: true,
      abOption,
    });
  }

  render() {
    const {
      changeEndorsementAcceptance,
      charity,
      isEndorsementAccepted,
    } = this.props;

    const { displayCharityOptions, abOption } = this.state;

    if (!displayCharityOptions) {
      return null;
    }

    return abOption === CharityEndorsedCommitment.Endorsement ? (
      <CreateEndorsedPage
        charity={charity}
        isEndorsementAccepted={isEndorsementAccepted}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          changeEndorsementAcceptance(e.target.checked, 'Endorsement')
        }
      />
    ) : (
      <CreateCommittedPage
        charity={charity}
        isEndorsementAccepted={isEndorsementAccepted}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          changeEndorsementAcceptance(e.target.checked, 'Commitment')
        }
      />
    );
  }
}

export default CreateCharityEndorsedPage;



// WEBPACK FOOTER //
// ./src/components/CharityEndorsed/CreateCharityEndorsedPage.tsx